import type { ExcursionPage } from "../slug-excursions";
import monaco from "@/assets/images/excursions/destinations/monaco.webp";

const page: ExcursionPage = {
  slug: "nice-monaco",
  hero: {
    title: "Excursion Nice – Monaco",
    subtitle:
      "Découvrez la Côte d’Azur entre Nice et la Principauté de Monaco avec un chauffeur privé.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: monaco,
  },
  generic: {
    heading: "Panorama Méditerranéen",
    paragraphs: [
      "Partez de Cannes pour explorer Nice, sa Promenade des Anglais, puis cap sur Monaco et le Rocher.",
    ],
  },
  highlights: {
    title: "Points forts",
    items: [
      {
        text: "Promenade des Anglais, colline du Château et vieille ville de Nice",
      },
      { text: "Principauté de Monaco : Rocher, casino, jardins, port Hercule" },
      {
        text: "Corniches panoramiques, pauses photos et suggestions gourmandes",
      },
      { text: "Départ/retour flexibles à Cannes et alentours" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      {
        title: "Départ de Cannes",
        description: "Prise en charge à l'adresse de votre choix.",
      },
      {
        title: "Nice",
        description:
          "Promenade des Anglais, vieille ville, marché (selon jour).",
      },
      { title: "Monaco", description: "Rocher, casino, port, temps libre." },
      {
        title: "Retour à Cannes",
        description: "Trajet confortable et ponctuel.",
      },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      {
        label: "Durée",
        value: "4 à 8 heures selon vos envies (suggestion : 6h)",
      },
      { label: "Départ", value: "Cannes et alentours" },
      {
        label: "Inclus",
        value: "Chauffeur privé, eau, Wi‑Fi, itinéraire personnalisé",
      },
      {
        label: "Option",
        value: "Temps libre shopping / musée selon ouverture",
      },
    ],
  },
};

export default page;
